import { cva } from 'class-variance-authority';

const fieldVariants = cva(
  'eye:group/field eye:flex eye:w-full eye:gap-4 eye:data-[invalid=true]:text-red-100',
  {
    variants: {
      orientation: {
        vertical: ['eye:flex-col eye:[&>*]:w-full eye:[&>.sr-only]:w-auto'],
        horizontal: [
          'eye:flex-row eye:items-center eye:gap-12',
          'eye:[&>[data-slot=field-label]]:flex-auto',
          'eye:has-[>[data-slot=field-content]]:items-start eye:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px',
        ],
        responsive: [
          'eye:flex-col eye:@md/field-group:flex-row eye:@md/field-group:items-center eye:[&>*]:w-full eye:@md/field-group:[&>*]:w-auto eye:[&>.sr-only]:w-auto',
          'eye:@md/field-group:[&>[data-slot=field-label]]:flex-auto',
          'eye:@md/field-group:has-[>[data-slot=field-content]]:items-start eye:@md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px',
        ],
      },
    },
    defaultVariants: {
      orientation: 'vertical',
    },
  },
);

export { fieldVariants };
